import React, { useState } from "react";
import { LogOut } from "lucide-react";
import UserAvatar from "../atoms/UserAvatar";

const UserMenu = ({ userName, isOpen, onToggle, onSignOut }) => {
  const [isSigningOut, setIsSigningOut] = useState(false);

  const handleSignOutClick = async () => {
    setIsSigningOut(true);
    try {
      await onSignOut();
    } finally {
      setIsSigningOut(false);
    }
  };

  return (
    <div className="relative" onClick={(e) => e.stopPropagation()}>
      <UserAvatar userName={userName} onClick={onToggle} isActive={isOpen} />

      {isOpen && (
        <div
          className="absolute top-full right-0 bg-white border border-gray-200 rounded-xl shadow-lg z-50 min-w-[180px] mt-2 overflow-hidden"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="px-4 py-3 bg-gray-50 border-b border-gray-100">
            <div className="text-[11px] text-gray-400 uppercase tracking-wide">
              Signed in as
            </div>
            <div className="text-sm text-gray-800 font-medium mt-0.5 truncate">
              {userName}
            </div>
          </div>
          <button
            onClick={handleSignOutClick}
            disabled={isSigningOut}
            className="w-full px-4 py-3 text-left cursor-pointer text-sm text-gray-600 font-medium flex items-center gap-2 hover:bg-red-50 hover:text-red-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <LogOut size={16} />
            <span>{isSigningOut ? "Signing out..." : "Sign Out"}</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default UserMenu;
